// Utility function to clear authentication tokens and redirect to login
export const clearAuthAndRedirect = () => {
  // Clear all stored authentication data
  localStorage.removeItem('authToken');
  localStorage.removeItem('userData');
  
  // Clear any other potential auth-related items
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('partner');
  localStorage.removeItem('partnerData');
  
  // Redirect to login page
  window.location.href = '/login';
};

// Function to check if user should be logged out due to token expiration
export const checkTokenExpiration = () => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    return true; // No token, should be logged out
  }
  
  try {
    // Decode JWT token to check expiration
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    
    if (payload.exp && payload.exp < currentTime) {
      // Token is expired, but don't redirect automatically
      // Let the AuthContext handle the cleanup
      return true;
    }
    
    return false; // Token is still valid
  } catch (error) {
    console.error('Error checking token expiration:', error);
    // If we can't decode the token, assume it's invalid
    return true;
  }
}; 